import HiddenFields from "./HiddenFields";
import { useToursContext } from "./context";
import { Checkbox } from 'react-icheck';
import React from "react";

export default function FilterForm() {


    const {
        page: { formId: id, request },
        handleFormSubmit
    } = useToursContext();


    const formId = "filters-form-" + id;


    return (
        <form id={formId}>
            <HiddenFields omit={'tour_category'}/>

            <div className="row form-row mb-3">
                <div className="col-6">
                    <div className="card border z-depth-0">
                        <div className="card-body px-3 py-2">
                            <div className="text-right">
                                <Checkbox
                                    name="tour_category[]"
                                    value="private-tours"
                                    checkboxClass="icheckbox_minimal"
                                    onChange={() => handleFormSubmit(formId)}
                                    defaultChecked={(_.findIndex(request.tour_category, (_tour_category) => { return _tour_category == "private-tours"; }) > -1) ? (true) : (false)}
                                />
                            </div>
                            <div className="text-center">
                                <i className="fa fa-lg fa-fw fa-user-friends"></i>
                                <div className="text-uppercase font-small">Private Tours</div>
                                <h4 className="d-none d-lg-block">with my own people</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="card border z-depth-0">
                        <div className="card-body px-3 py-2">
                            <div className="text-right">
                                <Checkbox
                                    name="tour_category[]"
                                    value="shared-tours"
                                    checkboxClass="icheckbox_minimal"
                                    onChange={() => handleFormSubmit(formId)}
                                    defaultChecked={(_.findIndex(request.tour_category, (_tour_category) => { return _tour_category == "shared-tours"; }) > -1) ? (true) : (false)}
                                />
                            </div>
                            <div className="text-center">
                                <i className="fa fa-lg fa-fw fa-users"></i>
                                <div className="text-uppercase font-small">Shared Tours</div>
                                <h4 className="d-none d-lg-block">with other people</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}


// WEBPACK FOOTER //
// ./resources/js/react/components/ToursIndex/FilterForm.jsx